import React from 'react';
import { Card, Progress, Typography, Space, Tag, Statistic, Row, Col } from 'antd';
import { 
  CheckCircleOutlined, 
  CloseCircleOutlined, 
  SyncOutlined,
  MailOutlined,
  ClockCircleOutlined 
} from '@ant-design/icons';

const { Text, Title } = Typography;

const BulkUploadProgress = ({ progress }) => {
  if (!progress) return null;

  const { percent, sent, failed, total, remaining, duration } = progress;
  const isComplete = percent === 100;

  return (
    <Card
      style={{
        marginBottom: 16,
        borderRadius: 8,
        border: `2px solid ${isComplete ? '#52c41a' : '#3497D3'}`,
        background: isComplete ? '#f6ffed' : '#e6f4ff'
      }}
      bodyStyle={{ padding: '16px' }}
    >
      <Space direction="vertical" size={12} style={{ width: '100%' }}>
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Title level={5} style={{ margin: 0, color: isComplete ? '#52c41a' : '#3497D3' }}>
            {isComplete ? (
              <><CheckCircleOutlined /> Email Notifications Complete</>
            ) : (
              <><SyncOutlined spin /> Sending Email Notifications...</>
            )}
          </Title>
          <Tag color={isComplete ? 'success' : 'processing'} style={{ fontSize: 13 }}>
            {Math.round(percent)}%
          </Tag>
        </div>

        {/* Progress Bar */}
        <Progress
          percent={Math.round(percent)}
          status={isComplete ? 'success' : 'active'}
          strokeColor={{
            from: '#3497D3',
            to: '#52c41a',
          }}
          trailColor="#d9d9d9"
        />

        {/* Statistics */}
        <Row gutter={[16, 8]}>
          <Col xs={12} sm={6}>
            <Statistic
              title={<Text type="secondary" style={{ fontSize: 12 }}>Total</Text>}
              value={total}
              prefix={<MailOutlined style={{ color: '#3497D3' }} />}
              valueStyle={{ fontSize: 18, color: '#3497D3' }}
            />
          </Col>
          <Col xs={12} sm={6}>
            <Statistic
              title={<Text type="secondary" style={{ fontSize: 12 }}>Sent</Text>}
              value={sent}
              prefix={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
              valueStyle={{ fontSize: 18, color: '#52c41a' }}
            />
          </Col>
          {failed > 0 && (
            <Col xs={12} sm={6}>
              <Statistic
                title={<Text type="secondary" style={{ fontSize: 12 }}>Failed</Text>}
                value={failed}
                prefix={<CloseCircleOutlined style={{ color: '#ff4d4f' }} />}
                valueStyle={{ fontSize: 18, color: '#ff4d4f' }}
              />
            </Col>
          )}
          {!isComplete && remaining > 0 && (
            <Col xs={12} sm={6}>
              <Statistic
                title={<Text type="secondary" style={{ fontSize: 12 }}>Remaining</Text>}
                value={remaining}
                prefix={<ClockCircleOutlined style={{ color: '#faad14' }} />}
                valueStyle={{ fontSize: 18, color: '#faad14' }}
              />
            </Col>
          )}
          {isComplete && duration && (
            <Col xs={12} sm={6}>
              <Statistic
                title={<Text type="secondary" style={{ fontSize: 12 }}>Duration</Text>}
                value={duration}
                suffix="s"
                prefix={<ClockCircleOutlined style={{ color: '#8c8c8c' }} />}
                valueStyle={{ fontSize: 18, color: '#8c8c8c' }}
              />
            </Col>
          )}
        </Row>

        {/* Status Message */}
        <div style={{ 
          padding: '8px 12px', 
          background: 'rgba(255, 255, 255, 0.8)', 
          borderRadius: 4,
          fontSize: 13
        }}>
          {isComplete ? (
            <Text style={{ color: '#52c41a' }}>
              ✅ Successfully sent {sent} welcome emails
              {failed > 0 && ` (${failed} failed)`}
              {duration && ` in ${duration}s`}
            </Text>
          ) : (
            <Text style={{ color: '#3497D3' }}>
              📧 Sending welcome emails to new enrollees... {sent} of {total} sent
            </Text>
          )}
        </div>
      </Space>
    </Card>
  );
};

export default BulkUploadProgress;


// Why aren't these files in the same folder as the other files?